import React from 'react';
import { releaseConfig } from '../config/releaseConfig';

function AlbumCover({ imageSrc }) {
  return (
    <div className="album-cover-container">
      <div className="album-cover-wrapper">
        <img 
          src={releaseConfig.song.albumCover} 
          alt="Album Cover" 
          className="album-cover" 
          loading="lazy"
        />
      </div>
    </div>
  );
}

export default AlbumCover;